enum AdminContactRequestType {
	IMPROVEMENT = 'improvement',
	BUG_PARTIAL_BLOCKING = 'bug_partial_blocking',
	BUG_FULLY_BLOCKING = 'bug_fully_blocking',
	EXPLAIN_FUNCTIONALITY = 'explain_functionality'
}

export default AdminContactRequestType
